import axios from "axios";
import Toaster from "../components/Toaster";
import router from "../router";

/**
 * Mostra a resposta no toaster, caso venha mensagem do backend.
 *
 * @param Response response dados que foram enviados
 *
 */

function responseHandler (response) {
  if (!response.data.hasOwnProperty("message")) {
    return;
  }

  let data = response.data;
  let status = data.status;
  let message = data.message;

  if (status == undefined) status = "error";
  let title = "";

  if (status === "success") {
    title = "Sucesso";
  }
  if (status === "error") {
    title = "Erro";
  }
  if (status === "info") {
    title = "Nota:";
  }
  if (status === "warn") {
    title = "Atenção";
  }

  Toaster.toast({ title: title, message: message, status: status });
}

axios.interceptors.response.use(
  (response) => {
    responseHandler(response);
    return response;
  },
  (error) => {
    const { status, data } = error.response;
    if (status === 403) {
      data;
      router.push("/painel");
    }

    if (status === 422) {
      Toaster.toast({ 
        title: "Atenção", 
        message: "Por favor, verifique os campos destacados em vermelho", 
        status: "error" 
      });
      return Promise.reject(error.response);
    }

    if (
      !error.config.hasOwnProperty("errorHandle") ||
      error.config.errorHandle !== false
    ) {
      responseHandler(error.response);
    }

    return Promise.reject(error.response);
  }
);

export default responseHandler;
